import { Group, GroupProps, StackProps, Stack } from '@mantine/core';
import { ReactNode } from 'react';

interface ConditionalLayoutProps {
  inlineCondition?: boolean; // if true -> horizontal, otherwise stacked
  gap?: number | string; // optional spacing between children
  children: ReactNode;
}

export function ConditionalLayout(props: ConditionalLayoutProps & (GroupProps | StackProps)) {
  const { inlineCondition = false, gap = 'xs', children, ...rest } = props;

  if (inlineCondition) {
    return (
      <Group gap={gap} {...(rest as GroupProps)}>
        {children}
      </Group>
    );
  }
  return (
    <Stack gap={gap} {...(rest as StackProps)}>
      {children}
    </Stack>
  );
}
